import { z } from "zod";

import { looseArray } from "../looseParse";

export const accountAccessRoleSchema = z.enum(["primary"]);

export const accountAccessResponseSchema = z.object({
  account_id: z.string(),
  // Per-item, not per-array: one role with an unrecognized value must not
  // erase every other valid role the account actually has.
  roles: looseArray(
    accountAccessRoleSchema,
    "accountAccessResponseSchema.roles",
  ),
});

export const accountAccessRoleAssignmentSchema = z.object({
  email: z.string(),
  role: accountAccessRoleSchema,
});

export const accountAccessRolesResponseSchema = z.object({
  account_id: z.string(),
  roles: looseArray(
    accountAccessRoleAssignmentSchema,
    "accountAccessRolesResponseSchema.roles",
  ),
  next_cursor: z.string().nullable(),
});
